import { hasProtocol, joinURL } from 'ufo'
import { SITE_NAME } from './siteName'

// Mirrors schemaOrg.identity in nuxt.config.ts; URL and dimensions change as a set.
const DEFAULT_LOGO = {
  url: 'https://www.180medical.com/images/180-logo.png',
  width: 283,
  height: 153,
}

interface CmsLogo {
  imageUrl?: string
  imageAltText?: string
  width?: number
  height?: number
}

function absoluteUrl(url: string, origin?: string): string {
  return hasProtocol(url) || !origin ? url : joinURL(origin, url)
}

// Set explicitly because nuxt-schema-org's organization resolver moves `logo` off
// the identity node onto an unreferenced #organization node, leaving the publisher
// link it adds by default pointing at an Organization with no logo.
export function buildPublisher(appSettings: any, origin?: string): any {
  const cms: CmsLogo | undefined = [
    appSettings?.headerSettings?.headerLogo,
    appSettings?.footerSettings?.footerLogo,
  ].find((logo: CmsLogo) => typeof logo?.imageUrl === 'string' && logo.imageUrl.trim().length > 0)

  const logo = cms
    ? {
        url: absoluteUrl(cms.imageUrl!.trim(), origin),
        caption: cms.imageAltText,
        width: cms.width,
        height: cms.height,
      }
    : { ...DEFAULT_LOGO, caption: SITE_NAME }

  return {
    '@type': 'Organization',
    'name': SITE_NAME,
    'logo': {
      '@type': 'ImageObject',
      'url': logo.url,
      ...(logo.caption ? { caption: logo.caption } : {}),
      ...(logo.width ? { width: logo.width } : {}),
      ...(logo.height ? { height: logo.height } : {}),
    },
  }
}
